// extracted by mini-css-extract-plugin
export default {"root":"BlockClientCard_root__2Qyv3","media":"BlockClientCard_media__moc59","text":"BlockClientCard_text__0w7Pr","clientContainer":"BlockClientCard_clientContainer__7c4dy"};